import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  categories: [],
  category: {},
  categoryType: "", // Added to specifically track category type
  title: "",
  contentType: "",
  genres: [],
  trailerFile: "",
  masterFile: "",
  posterFiles: "",
  loading: false,
  complianceChecked: false,
  isSeries: false,
  isVodcastSeries: false, // Added for Vodcast
  isDreamKidsSeries: false, // Added for DreamKids
  seriesID: "",
  albumId: "",
  mediaType: "",
  seasonsList: [],
  selectedSeasonsList: [],
  seasonCreated: false,
  selectedItems: [],
  csvBatchData: [],
  isAlbum: false,
  licensingRegions: [],
  airlineOptions: [],
  complianceOpen: false,
  albumCreated: false,
  productionCompanies: [],
  isDevotionMultiple: false,
  submittedSuccessfully: false,
  host: "",
  guests: [],
  educationalValue: "",
  ageGroup: "",
};

export const contentForm = createSlice({
  name: "contentForm",
  initialState,
  reducers: {
    setCategory: (state, action) => {
      state.category = action.payload;
    },
    setCategoryType: (state, action) => {
      state.categoryType = action.payload;
    },
    setCategories: (state, action) => {
      state.categories = action.payload;
    },
    setGenres: (state, action) => {
      state.genres = action.payload;
    },
    setTrailerFile: (state, action) => {
      state.trailerContentFile = action.payload;
    },
    setMasterFile: (state, action) => {
      state.masterFile = action.payload;
    },
    setPosterFiles: (state, action) => {
      state.selectedPosterFiles = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setComplianceChecked: (state, action) => {
      state.complianceChecked = action.payload;
      if (state.complianceOpen) {
        state.complianceOpen = false;
      }
    },
    setIsSeries: (state, action) => {
      state.isSeries = action.payload;
    },
    setIsVodcastSeries: (state, action) => {
      state.isVodcastSeries = action.payload;
    },
    setIsDreamKidsSeries: (state, action) => {
      state.isDreamKidsSeries = action.payload;
    },
    setSeriesID: (state, action) => {
      state.seriesID = action.payload;
    },
    setSelectedSeasonsList: (state, action) => {
      state.selectedSeasonsList = action.payload;
    },
    setSeasonCreated: (state, action) => {
      state.seasonCreated = action.payload;
    },
   setSelectedItems: (state, action) => {
  // If payload is an array, replace existing items
  if (Array.isArray(action.payload)) {
    state.selectedItems = action.payload;
  } 
  // If payload is a single item, append it
  else {
    state.selectedItems = [...state.selectedItems, action.payload];
  }
},
    setCSVBatchData: (state, action) => {
      state.csvBatchData = action.payload;
    },
    setContentType: (state, action) => {
      state.contentType = action.payload;
    },
    setIsAlbum: (state, action) => {
      state.isAlbum = action.payload;
    },
    setAlbumId: (state, action) => {
      state.albumId = action.payload;
    },
    setLicensingRegions: (state, action) => {
      state.licensingRegions = action.payload;
    },
    setAirlineOptions: (state, action) => {
      state.airlineOptions = [...state.airlineOptions, ...action.payload];
    },
    handleComplianceOpen: (state, action) => {
      state.complianceOpen = action.payload;
    },
    clearContentForm: (state) => {
      return initialState;
    },
    albumCreated: (state, action) => {
      state.albumCreated = true;
    },
    setProductionCompanies: (state, action) => {
      state.productionCompanies = action.payload;
    },
    setIsDevotionMultiple: (state, action) => {
      state.isDevotionMultiple = action.payload;
    },
    submitSuccessfully: (state, action) => {
      state.submittedSuccessfully = action.payload;
    },
    setMediaType: (state, action) => {
      state.mediaType = action.payload;
    },
    // New actions for Vodcast
    setHost: (state, action) => {
      state.host = action.payload;
    },
    setGuests: (state, action) => {
      state.guests = action.payload;
    },
    // New actions for DreamKids
    setEducationalValue: (state, action) => {
      state.educationalValue = action.payload;
    },
    setAgeGroup: (state, action) => {
      state.ageGroup = action.payload;
    },
    setContentForm: (state, action) => {
      return { ...state, ...action.payload };
    },
  },
});

// Export all actions including new ones
export const {
  setCategory,
  setCategoryType,
  setCategories,
  setGenres,
  setTrailerFile,
  setPosterFiles,
  setMasterFile,
  setLoading,
  setIsSeries,
  setIsVodcastSeries,
  setIsDreamKidsSeries,
  setSeriesID,
  setSelectedSeasonsList,
  setComplianceChecked,
  setSeasonCreated,
  setSelectedItems,
  setAlbumId,
  setContentType,
  setCSVBatchData,
  setIsAlbum,
  setLicensingRegions,
  setAirlineOptions,
  handleComplianceOpen,
  clearContentForm,
  albumCreated,
  setProductionCompanies,
  setIsDevotionMultiple,
  submitSuccessfully,
  setMediaType,
  // New Vodcast actions
  setHost,
  setGuests,
  // New DreamKids actions
  setEducationalValue,
  setAgeGroup,
  setContentForm,
} = contentForm.actions;

export default contentForm.reducer;